import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopLogoBarComponent } from './top-logo-bar.component';
import { OpsUserMenuComponent } from '@ops/storybook';
import { SpinnerComponent } from '../spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpsUserMenuComponent,
    SpinnerComponent,
    TranslateModule,
  ],
  exports: [TopLogoBarComponent],
  declarations: [TopLogoBarComponent],
})
export class TopLogoBarModule {}
